"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExceedsPreauthBanner = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_i18next_1 = require("react-i18next");
const orders_module_scss_1 = __importDefault(require("../orders.module.scss"));
const ExceedsPreauthBanner = ({ variant = 'pill', }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const className = variant === 'alert'
        ? orders_module_scss_1.default.exceedsPreauthAlert
        : orders_module_scss_1.default.exceedsPreauthBanner;
    return ((0, jsx_runtime_1.jsxs)("div", { className: className, role: "status", children: [(0, jsx_runtime_1.jsx)("i", { className: "pi pi-exclamation-triangle text-amber-600", "aria-hidden": "true" }), (0, jsx_runtime_1.jsx)("span", { children: t('exceedsPreauth.listBanner') })] }));
};
exports.ExceedsPreauthBanner = ExceedsPreauthBanner;
